export default __webpack_public_path__ + "static/media/sponsor.6e5c76b8.svg";